module.exports = __webpack_public_path__ + "img/2x.cac25e3.jpg";